/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { AppContext } from '../../App';
import Bet from '../../common/Bet';
import { BetsExpandCollapseContext } from '../../common/BetsExpandCollapseContext';
import { GroupedViewBet } from '../../common/GroupedView';
import Legend from '../../common/Legend';
import Stats from '../../common/Stats';
import { GROUPED_VIEW_MARKETS } from '../../data/constants';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import { handleCanonicalUrl } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { labels } from '../../data/labels';
import { PrematchContext } from '../Prematch';
import { MatchContext } from './MatchDataFetcher';

function Match(props) {
    const appContext = React.useContext(AppContext);
    const seoContext = React.useContext(SeoContext);
    const prematchContext = React.useContext(PrematchContext);
    const matchContext = React.useContext(MatchContext);
    const betsExpandCollapseContext = React.useContext(BetsExpandCollapseContext);
    const isAggregataTutte = props.aggregata < 0;
    const matchPath = props.urlPath;
    const absoluteMatchPath = useAbsolutePath(matchPath,null,props.urlPathSeo);

    // function getParentsUrlPath(){
    //     return [{'path':props.tournamentUrlPath,'suffix':props.tournamentUrlPathSuffix},{'path':props.sportUrlPath,'suffix':props.sportUrlPathSuffix}];
    // }

    useEffect(() => {
        window.scrollTo({top: 0});
    }, []);

    useEffect(() => {
        if(!window.appConfig.SHOP_MODE){
            if(window.history){
               seoContext.refreshPathname(matchPath,appContext.location.current);
               handleCanonicalUrl(absoluteMatchPath);
               //window.history.replaceState(window.history.state, null, absoluteMatchPath);
            }
            return () =>{
                //appContext.location.current === 'prematch' && window.history.replaceState(window.history.state, null, absoluteMatchPath.substring(0,absoluteMatchPath.indexOf(props.urlPath)));
            }
        }    
    }, [props.urlPath]);

    function closeStats() {
        prematchContext.toggleStats();
    }
    
    let bets = props.bets;
    if (matchContext?.favoritesSelected) {
        bets = bets.filter(bet => {
            return matchContext.isMarketFavorite(matchContext.match.sportRef, `${bet.id}_${bet.handicap}`);
        });
    }
    // bets = filtraParametriche(bets);

    let groupedView = false;
    if (bets.length === 1 && GROUPED_VIEW_MARKETS.includes(bets[0].cs)) {
        groupedView = true;
    }

    return (
        <div className="overlay-container">
            {prematchContext.showStats &&
                <Stats url={prematchContext.statsUrl} close={closeStats} />
            }
            <ul id="oddslist">
                {matchContext?.favoritesSelected && bets.length === 0 ?
                    <div className="text-center">{labels['favorite_markets.add_markets']}</div>
                    :
                    <>
                        {bets.filter(b => b.hasOdds).map((b, i) => {
                            const toggleCollapseId =`${props.uniqueId}_${props.aggregata}_${b.id}_${i}`;
                            function isExpanded(id) {
                                if (betsExpandCollapseContext.isBetCollapsed(id)) {
                                    return false;
                                } else {
                                    return betsExpandCollapseContext.isBetUndefinedCollapsed(id) ? (isAggregataTutte ? b.belongsMainGroup !== false : true) : true;
                                }
                            }
                            const expanded = isExpanded(toggleCollapseId);

                            {/* if (b.parametrica) {
                                return (
                                    <BetWrapper key={b.uniqueId}
                                                desc={b.desc}
                                                bets={props.betsById.get(b.id)}
                                                toggleCollapseId={toggleCollapseId}
                                                expanded={expanded}
                                    />
                                );
                            } */}

                            return (
                                <React.Fragment key={b.uniqueId}>
                                    {groupedView ?
                                        <GroupedViewBet toggleCollapseId={toggleCollapseId} expanded={expanded} match={props} bet={b} />
                                        :
                                        <Bet toggleCollapseId={toggleCollapseId} {...b} expanded={expanded} />
                                    }
                                </React.Fragment>
                            );
                        })}
                    </>
                }
            </ul>
            <Legend />
        </div>
    );
}

export default Match;